import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import ReactDOM from 'react-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getGlobalDictionaryTerm } from '../../utils';
var ALERT_BANNER = 'alertBanner';
var CloseIcon = function CloseIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.974",
    height: "12.974"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m11.207,0.707l1.06,1.06l-4.72,4.72l4.72,4.72l-1.06,1.06l-4.72,-4.72l-4.72,4.72l-1.06,-1.06l4.72,-4.72l-4.72,-4.72l1.06,-1.06l4.72,4.72l4.72,-4.72z"
  }));
};
var Banner = function Banner(_ref) {
  var text = _ref.text;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showAlertBanner = _React$useState2[0],
    setShowAlertBanner = _React$useState2[1];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var btnLabel = getGlobalDictionaryTerm(sitecoreContext, 'closeAnnouncementBannerLabel') || 'Close announcement banner';
  var btnTitle = getGlobalDictionaryTerm(sitecoreContext, 'close') || 'close';
  return showAlertBanner ? /*#__PURE__*/React.createElement("div", {
    "aria-label": "Alert Banner",
    role: "banner",
    className: "container d-print-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alertBanner__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alertBanner__text",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "alertBanner__button"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setShowAlertBanner(false);
    },
    "aria-label": btnLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text"
  }, btnLabel), /*#__PURE__*/React.createElement(CloseIcon, null)))))) : /*#__PURE__*/React.createElement("div", null);
};
var AnnouncementBanner = function AnnouncementBanner(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var text = get(fields, 'data.item.text.jss.value');
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    banner = _React$useState4[0],
    setBanner = _React$useState4[1];
  React.useEffect(function () {
    var bn;
    if (typeof window !== 'undefined') {
      bn = document.getElementById('announcement-banner');
      setBanner(bn);
      // hide inline banner using css style:
      // .alertBanner + .alertBanner {
      //   display: none;
      // }
      if (text && bn) {
        bn.classList.add(ALERT_BANNER);
        bn.classList.add(params.Color);
      }
    }
    return function () {
      bn && bn.classList.remove(ALERT_BANNER);
      bn && bn.classList.remove(params.Color);
    };
  }, []);
  return banner && text ? /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(Banner, {
    text: text
  }), banner) : null;
};
export default AnnouncementBanner;